import { apiRequest } from '@/api/helpers/apiRequest';
import { handleApiError } from '@/api/helpers/handleApiError';
import type { CreatePrintPdfResponse } from 'schemas/print-pdf';
import { CreatePrintPdfResponseSchema } from 'schemas/print-pdf';

type PrintStorySuccess = { signedUrl: string };

export async function printStory(storyId: string): Promise<string> {
  try {
    const result = await apiRequest<PrintStorySuccess, CreatePrintPdfResponse>(
      'POST',
      `/api/print-pdfs/${storyId}`,
      undefined,
      CreatePrintPdfResponseSchema
    );
    return result.signedUrl;
  } catch (error) {
    handleApiError(error);
  }
}
